<template>
  <div v-if="alerts.length" class="sticky-bottom">
    <div v-for="a in alerts"
      :class="`alert alert-${a.variant || 'primary'} p-2 d-flex justify-content-between align-items-center`"
      role="alert" :ref="`alert-${a.id}`" :key="a.id">
      {{ a.message }}
      <button v-if="a.duration === 0 || a.duration === undefined" type="button" class="btn-close" aria-label="Close"
        @click="dismissAlert(a.id)"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormAlert',
  props: {
    alerts: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      alertTimeouts: {},
      previousAlertIds: new Set()
    };
  },
  methods: {
    dismissAlert(id) {
      // console.log('dismissAlert triggered with id: %o', id);
      if (this.alertTimeouts[id]) {
        clearTimeout(this.alertTimeouts[id]);
        delete this.alertTimeouts[id];
      }
      this.$emit('dismiss-alert', id);
    },
    setDismissTimeout(alertEntity) {
      if (alertEntity.duration > 0) {
        if (this.alertTimeouts[alertEntity.id]) {
          clearTimeout(this.alertTimeouts[alertEntity.id]);
        }
        this.alertTimeouts[alertEntity.id] = setTimeout(() => {
          this.dismissAlert(alertEntity.id);
        }, alertEntity.duration);
      } else {
        if (this.alertTimeouts[alertEntity.id]) {
          clearTimeout(this.alertTimeouts[alertEntity.id]);
          delete this.alertTimeouts[alertEntity.id];
        }
      }
    }
  },
  watch: {
    alerts: {
      handler(newAlerts) {
        // console.log('--- Watcher Triggered ---');
        // console.log('newAlerts (snapshot):', JSON.parse(JSON.stringify(newAlerts || []))); // Deep copy for true snapshot
        // console.log('previousAlertIds:', [...this.previousAlertIds]);
        const currentAlertIds = new Set(newAlerts.map(a => a.id));
        newAlerts.forEach((alert) => {
            this.setDismissTimeout(alert);
        });

        this.previousAlertIds.forEach((oldId) => {
          if (!currentAlertIds.has(oldId)) {
            // console.log(`  Clearing timeout for removed alert ID: ${oldId}`);
            if (this.alertTimeouts[oldId]) {
              clearTimeout(this.alertTimeouts[oldId]);
              delete this.alertTimeouts[oldId];
            }
          }
        });

        this.previousAlertIds = currentAlertIds;

        // console.log('--- Watcher End ---');
      },
      deep: true,
      immediate: true,
    }
  },
  beforeUnmount() {
    for (const id in this.alertTimeouts) {
      clearTimeout(this.alertTimeouts[id]);
      delete this.alertTimeouts[id];
    }
  }
  // updated() {
  //   this.alert.forEach((a) => {
  //     // if duration provided and greater than 0, set a timeout
  //     if (a.duration > 0) {
  //       setTimeout(() => {
  //         this.dismissAlert(a.id);
  //       }, a.duration);
  //
  //     }
  //   });
  // },
}
</script>

<style lang="scss" scoped>
.alert {
  text-align: center;
}
</style>
